import React, { Component } from 'react'
import AWSAPI from '../../../common/AWSAPI'
import Config from '../../../Config'
import Loading from '../../../common/component/Loading'

const getPastMonths = () => {
  const months = [];
  const d = new Date();
  for (let i = 11; i >= 0; i--) {
    const month = new Date(d.getFullYear(), d.getMonth() - i, 1);
    const year = month.getFullYear();
    const m = (month.getMonth() + 1).toString().padStart(2, '0');
    months.push(`${year}/${m}`);
  }
  return months;
};

class PrefectureTotal extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isLoaded: false,
      stats: {}
    }
    this.apiUrl = Config.adminApiUrl.userManagement
    this.userRole = 'admin'
  }

  componentDidMount () {
    this.loadPrefectureTotalList()
  }

  loadPrefectureTotalList () {
    console.log("Starting API call to:", this.apiUrl); // ログ追加
    
    const onSuccess = (res) => {
      console.log('API Response:', res);

      const stats = res.body || res; 

      if (!stats || typeof stats !== 'object') {
        console.error('statsを取得できませんでした');
        return;
      }

      this.setState({
        isLoaded: true,
        stats: stats
      });
    }

    const params = {
      command: 'aggregate'
    }

    console.log("Request Params:", params);
    AWSAPI.apiPost(this.userRole, this.apiUrl, params, onSuccess)
  }

  render () {
    if (!this.state.isLoaded) {
      return <Loading />
    }

    const { stats } = this.state
    const months = getPastMonths()

    const prefOrder = Config.prefectures.nameOptions.map(p => p.name);

    return (
      <div>
        <section className='nav-page'>
          <div className='container'>
            <div className='row'>
              <div className='span8'>
                <header className='page-header'>
                  <h3>都道府県別ログイン集計<br /><small>過去12ヶ月の企業ユーザーのログイン情報を閲覧できます。</small></h3>
                </header>
              </div>
            </div>
          </div>
        </section>
        <section className='page container'>
          <div className='box'>
            <div className='box-header'>
              <i className='icon-info-sign icon-large' />
              <h5>都道府県別ログイン集計情報</h5>
            </div>
            <div className='box-content box-table'>
              <table className='table table-hover tablesorter'>
                <thead>
                  <tr>
                    <th width="20%">都道府県名</th>
                    {months.map(m => <th key={m}>{m}</th>)}
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(stats).sort((a, b) => {
                    const indexA = prefOrder.indexOf(a);
                    const indexB = prefOrder.indexOf(b);
                    return (indexA === -1 ? 99 : indexA) - (indexB === -1 ? 99 : indexB);
                  }).map(pref => {
                    return (
                      <tr key={pref}>
                        <td>{pref}</td>
                        {months.map(m => {
                          const count = stats[pref][m] || 0;
                          return <td key={m}>{count}</td>;
                        })}
                      </tr>
                    );
                  })}
                  {Object.keys(stats).length === 0 && (
                    <tr><td colSpan={months.length + 2} style={{textAlign: 'center'}}>データがありません</td></tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </section>
      </div>
    )
  }
}

export default PrefectureTotal



// WEBPACK FOOTER //
// ./src/admin/pages/secure/PrefectureTotal.js